<template>
<div>
  <div class="playerbg"></div>
    <div class="width-css">
      <div class="img-css"><img :src="detail.image"/></div>
      <span class="player-name">{{ detail.name }}</span>
      <div class="num-css">
        <span>{{ detail.unitName }}</span>
        <span style="margin-left:50px;">积分 {{ detail.score }}</span>
        <span style="margin-left:50px;font-size:16px;">项目排名 <b>{{ rank }}</b></span>
      </div>
      <a-progress class="sum-match-num" type="circle" :percent="detail.winNum + detail.lostNum" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;">竞技场次<br/>
            {{ percent }}
          </span>
        </template>
      </a-progress>
      <a-progress class="match-num" type="circle" :percent="data.poomsae.total" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;">品势场次<br/>
            {{ percent }}
          </span>
        </template>
      </a-progress>
      <a-progress class="record-num" type="circle" :percent="(detail.winNum / (detail.winNum + detail.lostNum)) * 100" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;font-size:13px;">战绩<br/>
            {{ detail.winNum }}胜/{{ detail.lostNum }}负
            <span style="display: none;">{{ percent }}</span>
          </span>
        </template>
      </a-progress>
      <a-progress class="win-num" type="circle" :percent="(detail.winNum / (detail.winNum + detail.lostNum)) * 100" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;">胜率<br/>
            {{ parseInt(percent) }} %
          </span>
        </template>
      </a-progress>
    </div>
  <div class="box-css">
    <div class="type-css">
      <div>
        <span style="font-size:16px;">
          <b>竞技获胜方式统计</b>&ensp;&ensp;|&ensp;&ensp;
          共计胜场{{ detail.winNum }}场次
        </span>
      </div>
      <div id="main" style="height: 300px;"></div>
      <div class="type-font-box">
        <div>PTF：以最终比分获胜</div>
        <div>PTG：以分差获胜</div>
        <div>DSQ：以对方失去资格获胜</div>
        <div>KO：击倒胜</div>
        <div>RSC：以主裁判终止比赛获胜</div>
        <div>PUN：以判罚对方犯规致获胜</div>
        <div>GDP：以加时赛先得分获胜</div>
        <div>SUP：以优势判定获胜</div>
        <div>WDR：以对方弃权获胜</div>
        <div>WIN：比分判胜</div>
      </div>
    </div>
    <div class="radar-css">
      <div>
        <span class="radar-span">
          <b>攻防对比</b>（近10场）
        </span>
      </div>
      <div id="main2" style="height: 300px;"></div>
      <span class="badge-a">
        <a-badge status="error" :text="attackDefense.defense.punchCount + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.punchCount + ''" />
      </span>
      <span class="badge-b">
        <a-badge status="error" :text="attackDefense.defense.warnCount + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.warnCount + ''" />
      </span>
      <span class="badge-c">
        <a-badge status="error" :text="attackDefense.defense.backCount + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.backCount + ''" />
      </span>
      <span class="badge-d">
        <a-badge status="error" :text="attackDefense.defense.bodyCount + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.bodyCount + ''" />
      </span>
      <span class="badge-e">
        <a-badge status="error" :text="attackDefense.defense.headCount + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.headCount + ''" />
      </span>
    </div>
    <div class="poomsae-css">
      <div style="margin-top:30px;">
        <span style="font-size:16px;">
          <b>品势分析</b>（近10场）
        </span>
      </div>
      <div v-if="data.poomsae !== null">
        <div class="poomsae-circle">
          <a-progress type="circle" style="margin-top:50px;margin-right:60px;" :percent="(data.poomsae.expressive / 6) * 100"  :width="230" :strokeWidth="13" strokeColor="#244e8f">
            <template #format="percent">
              <span style="display:none;">{{ percent }}</span>
              <font style="font-size:28px;"><b>{{ data.poomsae.expressive }} / 6</b> </font><br/><br/> <font style="font-size:18px;color:gray;">表现力</font>
            </template>
          </a-progress>
          <a-progress type="circle" :percent="(data.poomsae.accuracy / 4) * 100"  :width="230" :strokeWidth="13" strokeColor="#04b4e5">
            <template #format="percent">
              <span style="display:none;">{{ percent }}</span>
              <font style="font-size:28px;"><b>{{ data.poomsae.accuracy }} / 4</b> </font><br/> <br/> <font style="font-size:18px;color:gray;">准确度</font>
            </template>
          </a-progress>
        </div>
        <div class="time-list">
          <div class="time-item" style="font-weight:bold;">
            <div class="time-item-li">比赛时间</div>
            <div class="time-item-li">表现力</div>
            <div class="time-item-li">准确度</div>
            <div class="time-item-li">总分</div>
          </div>
          <div class="time-item" v-for="(item,index) in data.poomsae.details" :key="index" :style="{background: index % 2 === 0 ? 'white' : 'rgb(241, 241, 241)'}">
            <div class="time-item-li">{{ matchFun.formatDate(item.time) }}</div>
            <div class="time-item-li">{{ item.expressive }}</div>
            <div class="time-item-li">{{ item.accuracy }}</div>
            <div class="time-item-li">{{ item.score }}</div>
          </div>
        </div>
      </div>
      <a-empty v-else/>
    </div>
    <div class="power-css">
      <div class="power-head">
        <div style="margin-top:30px;margin-bottom:30px;">
          <span style="font-size:16px;">
            <b>力量分析</b>（近10场）
          </span>
        </div>
        <div v-if="data.power !== null">
          <div style="height:70px;">
            <div class="power-gat">
              <b>{{ data.power.maxPower }}</b>KPI<br/>最大爆发
            </div>
            <div class="power-gat">
              <b>{{ data.power.totalPower }}</b>KPI<br/>总力度
            </div>
          </div>
          <div style="position: relative;margin-top:5px;" v-for="(item,index) in data.power.details" :key="index">
            <span style="margin-left:20px;">{{ matchFun.formatDate(item.time) }}</span>
            <span class="time-line">{{ item.powerNum }}KPI</span>
            <a-progress
              status="active"
              :stroke-color="{
                '0%': '#049b18',
                '100%': '#ffcf01',
              }"
              :strokeWidth="22"
              :percent="(item.powerNum / 300) * 100"
              :show-info="false"
            />
          </div>
        </div>
        <a-empty v-else/>
      </div>
      <div class="fast-box">
        <div style="margin-top:30px;margin-bottom:30px;">
          <span style="font-size:16px;">
            <b>速度分析</b>（近10场）
          </span>
        </div>
        <div v-if="data.speed !== null">
          <div style="height:70px;">
            <div class="speed-head">
              <b>{{ data.speed.best }}</b>次/20秒<br/>最佳速度
            </div>
            <div class="speed-head">
              <b>{{ data.speed.fast }}</b>次/秒<br/>最快速度
            </div>
          </div>
          <div style="position: relative;margin-top:5px;" v-for="(item,index) in data.speed.details" :key="index">
            <span style="margin-left:20px;">{{ matchFun.formatDate(item.time) }}</span>
            <span class="time-line">{{ item.num }}次</span>
            <a-progress
              status="active"
              :stroke-color="{
                '0%': '#049b18',
                '100%': '#ffcf01',
              }"
              :strokeWidth="22"
              :percent="(item.num / 80) * 100"
              :show-info="false"
            />
          </div>
        </div>
        <a-empty v-else/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
import matchFun from '@comm/utils/matchFun.js'
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      rank: this.$route.query.rank,
      matchFun,
      detail: {},
      data: {
        basicData: {
          winNum: 0
        },
        poomsae: {
          expressive: 0,
          accuracy: 0,
          details: [],
          total: 0
        },
        power: {
          maxPower: 0,
          totalPower: 0,
          details: []
        },
        speed: {
          best: 0,
          fast: 0,
          details: []
        }
      },
      attackDefense: {
        defense: {
          punchCount: 0,
          warnCount: 0,
          backCount: 0,
          bodyCount: 0,
          headCount: 0
        },
        attack: {
          punchCount: 0,
          warnCount: 0,
          backCount: 0,
          bodyCount: 0,
          headCount: 0
        }
      }
    }
  },
  created () {
    this.detail = JSON.parse(decodeURI(this.$route.query.detail))
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.playerTechnical({cardId: this.detail.cardId, programId: this.programId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.attackDefense = res.data.attackDefense
          this.drawData(res.data.winType)
          this.radarData(res.data.attackDefense)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    drawData (data) {
      let arr = []
      for (let key in data) {
        arr.push({
          value: data[key],
          name: key.toUpperCase() + '：' + data[key]
        })
      }
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#04b4e5', '#049b18', '#224f8a', '#006dd6', '#72c707', '#ffcf01', '#ff8a00', '#ff7200', '#ff4f01'],
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 30,
          top: 20,
          bottom: 20,
          itemHeight: 16
        },
        series: [
          {
            name: '数据',
            type: 'pie',
            radius: ['50%', '70%'],
            label: {
              show: false,
              position: 'center'
            },
            left: 0,
            top: 0,
            data: arr
          }
        ]
      }

      option && myChart.setOption(option)
    },
    radarData (data) {
      var chartDom = document.getElementById('main2')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'axis'
        },
        color: ['#04b4e5', '#ff4f01'],
        legend: {
          left: 'center',
          data: [
            '得分数据',
            '失分数据'
          ]
        },
        radar: [
          {},
          {
            indicator: [
              { text: '一分' },
              { text: '二分' },
              { text: '三分' },
              { text: '四分' },
              { text: '警告' },
              { text: '严重警告' }
            ],
            radius: 80,
            center: ['50%', '50%']
          }
        ],
        series: [
          {
            type: 'radar',
            radarIndex: 1,
            areaStyle: {},
            data: [
              {
                value: [data.defense.punchCount, data.defense.headCount, data.defense.bodyCount, data.defense.backCount, data.defense.warnCount],
                name: '得分数据'
              },
              {
                value: [data.attack.punchCount, data.attack.headCount, data.attack.bodyCount, data.attack.backCount, data.attack.warnCount],
                name: '失分数据'
              }
            ]
          }
        ]
      }

      option && myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.playerbg{
  height: 120px;
  padding-top: 40px;
  background-image: url('../../../../assets/weapon/playertopbg.png');

}
.width-css{
  width: 1200px;
  margin: 0 auto;
  height: 120px;
  position: relative;
  border-bottom: 5px solid rgb(238, 236, 236);
}
.img-css{
  position:absolute;
  top: -70px;
  width: 140px;
  height: 170px;
  border-radius:5px;
  background: white;
}
.width-css img{
  width: 110px;
  height: 140px;
  margin-left: 15px;
  margin-top: 15px;
}
.player-name{
  position:absolute;
  top: -70px;
  left: 150px;
  font-size: 25px;
  color:white;
}
.num-css{
  position:absolute;
  top: -30px;
  left: 150px;
  font-size: 14px;
  color:white;
}
.sum-match-num{
  position:absolute;
  top: 20px;
  left: 170px;
  font-size: 14px;
  color:white;
}
.match-num{
  position:absolute;
  top: 20px;
  left: 330px;
  font-size: 14px;
  color:white;
}
.record-num{
  position:absolute;
  top: 20px;
  left: 490px;
  font-size: 14px;
  color:white;
}
.win-num{
  position:absolute;
  top: 20px;
  left: 650px;
  font-size: 14px;
  color:white;
}
.box-css{
  width: 1200px;
  margin: 20px auto;
  overflow: hidden;
}
.type-css{
  width: 600px;
  float: left;
  height: 320px;
  border-right: 1px solid rgb(231, 231, 231);
  position: relative;
}
.radar-css{
  width: 600px;
  float: left;
  height: 320px;
  position: relative;
}
.poomsae-css{
  width: 1200px;
  float: left;
  height: 390px;
  position: relative;
  border-top: 5px solid rgb(238, 236, 236);
  border-bottom: 5px solid rgb(238, 236, 236);
  margin-top: 30px;
}
.time-list{
  width:600px;max-height: 300px;overflow-y: auto;float:left;
}
.time-item{
  width:100%;height:45px;line-height:45px;background:rgb(241, 241, 241);
}
.time-item-li{
  width:25%;height:45px;float:left;text-align: center;
}
.power-css{
  width: 1200px;
  float: left;
  height: 410px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
}
.time-line{
  position: absolute;top: 23px;left: 17px;z-index: 99;color:white;
}
.type-font-box{
  position: absolute;left: 0px;top: 40px;line-height:30px;color:gray;
}
.radar-span{
  font-size:16px;margin-left:20px;
}
.badge-a{
  position: absolute;top: 55px;left: 320px;line-height:15px;
}
.badge-b{
  position: absolute;top: 180px;left: 420px;line-height:15px;
}
.badge-c{
  position: absolute;top: 290px;left: 430px;line-height:15px;
}
.badge-d{
  position: absolute;top: 290px;left: 140px;line-height:15px;
}
.badge-e{
  position: absolute;top: 180px;left: 135px;line-height:15px;
}
.poomsae-circle{
  width:600px;height:300px;float:left;
}
.power-head{
  width:50%;float:left;padding-right:5%;border-right: 1px solid #e7e7e7;height:410px;
}
.power-gat{
  width:50%;height:70px;text-align: center;line-height: 30px;font-size: 16px;color:#ccc;float:left;
}
.speed-head{
  width:50%;height:70px;text-align: center;line-height: 30px;font-size: 16px;color:#ccc;float:left;
}
.fast-box{
  width:45%;float:left;padding-left:20px;
}
.speed-head b{
  font-size:30px;color:gray;
}
.power-gat b{
  font-size:30px;color:gray;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/module/SkillTaekwondo.vue